import { render, staticRenderFns } from "./UpContentAdsDialog.vue?vue&type=template&id=96f594de&"
import script from "./UpContentAdsDialog.vue?vue&type=script&lang=js&"
export * from "./UpContentAdsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpContentAdsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports